export default __webpack_public_path__ + "static/media/backBtn.c3f7846f.webp";